/**
 * @desc 计算价格
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<number>;
export function request(
  body: defs.tms.LogisticsQuotationPriceTobRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationTob/calculatePrice`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
